<script lang="ts" setup>
const props = defineProps({
  linkTitle: String,
  icon: {
    type: String,
    default: 'icon-arrow-right4'
  }
})
</script>

<template>
  <button class="button">
    <div class="button__title" v-if="props.linkTitle">{{ props.linkTitle }}</div>
    <div class="button__icon">
      <svg-icon :name="props.icon" />
    </div>
  </button>
</template>

<style lang="scss" scoped>
.button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: $color-gray-3;
  padding: toRem(11) toRem(10) toRem(11) toRem(24);
  color: $color-black-1;
  border: 1px solid $color-gray-3;
  &__title {
    font-size: toRem(16);
    margin-right: toRem(20);
  }
  &__icon {
    width: toRem(24);
    height: toRem(24);
    color: $color-gray-1;
  }
}
</style>
